import { FC } from 'react';
import { CarAllocation } from '../../../../../../types/carAllocation';
import styles from './styles.module.css';
import {
  WorkCategoryNames,
  getWorkCategoryIDByName,
} from '../../../../../../services/workCategory';
import { formatTime } from '../../../../../../services/formatTime';

type Props = {
  dayLabel: string;
  workStartTime: string;
  workEndTime: string;
  allocations: CarAllocation[];
  onClick?: (elem: HTMLElement) => void;
};
const TimeCellData: FC<Props> = ({
  workStartTime,
  workEndTime,
  allocations,
  onClick,
}) => {
  if (!allocations.length) {
    return null;
  }

  const collectCount = allocations.filter(
    (a) => a.workCategory.id === getWorkCategoryIDByName('回収')
  ).length;
  const loadingCount = allocations.filter(
    (a) => a.workCategory.id === getWorkCategoryIDByName('積込')
  ).length;
  const otherCount = (workCategory: WorkCategoryNames) =>
    allocations.filter(
      (a) => a.workCategory.id !== getWorkCategoryIDByName(workCategory)
    ).length;

  return (
    <div
      className={styles.cell}
      onClick={(event) => {
        event.stopPropagation();
        onClick?.(event.currentTarget);
      }}
    >
      <div className={styles.countLine}>
        <span className={styles.countText}>
          {collectCount > 0 ? '回収' : '積込'}
          <span className={styles.count}>
            {collectCount > 0 ? collectCount : loadingCount}
          </span>
          <span className={styles.unit}>件</span>
        </span>
        {otherCount(collectCount > 0 ? '回収' : '積込') > 0 && (
          <span className={styles.countText}>
            他
            <span className={styles.count}>
              {otherCount(collectCount > 0 ? '回収' : '積込')}
            </span>
            <span className={styles.unit}>件</span>
          </span>
        )}
      </div>
      <div className={styles.times}>{`${formatTime(workStartTime)}~${formatTime(
        workEndTime
      )}`}</div>
    </div>
  );
};

export default TimeCellData;
